import { render, staticRenderFns } from "./HowWorksBlock.vue?vue&type=template&id=15cfe958&scoped=true&"
import script from "./HowWorksBlock.vue?vue&type=script&lang=js&"
export * from "./HowWorksBlock.vue?vue&type=script&lang=js&"
import style0 from "./HowWorksBlock.vue?vue&type=style&index=0&id=15cfe958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cfe958",
  null
  
)

export default component.exports